<template>
  <table class="table table-sm mb-0">
    <thead>
      <tr>
        <td v-translate>Date</td>
        <td v-translate>Ava</td>
        <td v-translate>Full price</td>
        <td v-translate>Sale</td>
        <td v-translate></td>
      </tr>
    </thead>
    <tbody>
      <template v-for="(depDate, depDateIndex) in result.dates">
        <Date
          :depDate="depDate"
          :currency="result.currency"
          :key="'date' + depDateIndex"
          @selectDate="$emit('selectDate', $event)"
          @showPriceDetails="$emit('showPriceDetails', $event)" />
      </template>
    </tbody>
  </table>
</template>

<script>
import Date from './date.vue'
export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  components: {
    Date
  }
}
</script>
